var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../../components/Button";
import { Icon } from "../../components/Icon";
import { Card } from "../../components/Card";
import { goTo, onCardClick as defaultOnCardClick } from "./utils/sidebarUtils";
// styles
import "./sidebarBSSPlatformTools.scss";
const defaultProps = {
    className: "tecma-SidebarBSSPlatformTools",
    id: undefined,
    style: undefined,
    "data-testid": "tecma-SidebarBSSPlatformTools",
    onLinkClick: goTo,
    onCardClick: defaultOnCardClick,
};
const SidebarBSSPlatformTools = (_a) => {
    var { tools, imagesBaseUrl, bssPlatformLink, currentTool, labels, onLinkClick, onCardClick } = _a, rest = __rest(_a, ["tools", "imagesBaseUrl", "bssPlatformLink", "currentTool", "labels", "onLinkClick", "onCardClick"]);
    const { className } = rest, props = __rest(rest, ["className"]);
    return (_jsxs("div", Object.assign({ className: "tecma-SidebarBSSPlatformTools" }, props, { children: [_jsxs("div", { className: "sidebarBSSPlatformTools-header", children: [labels.title, _jsxs(Button, { className: "sidebarBSSPlatformTools-redirect-button", onClick: () => {
                            if (onLinkClick) {
                                onLinkClick(bssPlatformLink);
                            }
                        }, children: [labels.bssPlatform, _jsx(Icon, { iconName: "logout", className: "sidebarBSSPlatformTools-redirect-button-icon", size: "extra-small" })] })] }), tools.map((tool) => (_jsxs(Card, { className: "sidebarBSSPlatformTools-toolBox", orientation: "horizontal", selected: tool.name === currentTool, setSelected: () => {
                    if (onCardClick) {
                        onCardClick(tool.name, currentTool, tool.url);
                    }
                }, children: [_jsx(Card.Media, { className: "sidebarBSSPlatformTools-card-media-override", children: _jsx("img", { src: `${imagesBaseUrl}/${tool.name.toLowerCase()}.jpeg?v=${new Date().getDay()}`, alt: `${tool.name.toLowerCase()}`, className: "sidebarBSSPlatformTools-toolImage" }) }), _jsx(Card.Content, { className: "sidebarBSSPlatformTools-toolName", children: tool.name })] }, tool.name)))] })));
};
SidebarBSSPlatformTools.defaultProps = defaultProps;
export default SidebarBSSPlatformTools;
